import { useState, useEffect, useRef } from "react";
import Pencil from "../../images/icons/Pencil.svg";
import View from "../../images/icons/view-icon.svg";
import { useNavigate } from "react-router-dom";
import { encryptData, getLocalStorageUserData } from "../../utils/userData";
import { useDispatch } from "react-redux";
import { userVerifyLogin } from "../../actions/usersActions";

const Investor = ({ data, currentPage }) => {
  const getChipStyles = (statusClass, statusValue) => {
    if (statusClass === "N") {
      return {
        backgroundColor: "#fedfbe",
        color: "#f48109",
        fontWeight: "600",
      }; // Yellow background for 'Inactive'
    } else {
      return statusClass === "Y"
        ? { backgroundColor: "#aafec0", color: "#28ae70", fontWeight: "600" }
        : { backgroundColor: "#ffe6e6", color: "#dc3545", fontWeight: "600" };
    }
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleNavigation = (data) => {
    navigate("/rm/viewinvestor", { state: data });
  };

  const loginCustomer = (customerMobile) => {
    try {
      const userData = getLocalStorageUserData();
      console.log("userDa1111ta", userData);
      const encryptedRMUserData = encryptData(userData.mobile);
      localStorage.setItem("rmUserId", encryptedRMUserData);
      const encryptedCustomerData = encryptData(customerMobile);
      localStorage.setItem("customerId", encryptedCustomerData);
      localStorage.removeItem("login");
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      localStorage.removeItem("userId");

      const payload = {
        mobile: customerMobile,
        type: "R",
      };

      dispatch(userVerifyLogin(payload)).then((response) => {
        console.log("response111", response);
      });
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleEditNavigation = () => {
    navigate("/admin/investeredit");
  };

  const Goviewnachdetails = () => {
    navigate("/admin/viewnachdetails");
  };

  const GoMappingdetails = () => {
    navigate("/admin/viewmaping");
  };

  const Goinvestorstatus = () => {
    navigate("/admin/investorstatus");
  };

  const GoIINStatus = () => {
    navigate("/admin/iinstatus");
  };

  return (
    <div className="table-container table-responsive">
      <table className="table_transaction">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile Number</th>
            <th>UCID</th>
            <th>FATCA Status</th>
            {/* <th>KYC Status</th> */}
            <th>IIN Status</th>
            <th>Added Date</th>
            <th>Action</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data?.map((investor, index) => (
              <tr
                key={index}
                className={`${
                  investor?.investor?.trxn_status?.toLowerCase() ||
                  investor?.status?.toLowerCase()
                } transaction_row`}
              >
                {console.log("investor?.profileinvestor?.profile", investor)}
                <td>{(currentPage - 1) * 10 + index + 1}</td>
                <td className="white-space-normal">{investor?.name || "NA"}</td>
                <td>{investor?.email || "NA"}</td>
                <td>{investor?.mobile || "NA"}</td>
                <td>{investor?.customers?.client_code || "NA"}</td>
                <td>
                  <span
                    className={`investor-status investor-status-${
                      investor.OnboardJobStatus?.fatca_status == "REG_SUCCESS"
                        ? "active"
                        : "inactive"
                    }`}
                    style={{
                      ...getChipStyles(
                        investor.OnboardJobStatus?.fatca_status == "REG_SUCCESS"
                          ? "Y"
                          : "N"
                      ),
                      borderRadius: "15px",
                      padding: "5px 20px",
                      display: "inline-block",
                    }}
                  >
                    {investor.OnboardJobStatus?.fatca_status === "REG_SUCCESS"
                      ? "Active"
                      : "Inactive"}{" "}
                  </span>
                </td>

                {/* <td>
                {investor?.profile?.kyc_status && (
                  <span
                    className={`investor-status investor-status-${investor.profile?.kyc_status}`}
                    style={{
                      ...getChipStyles(investor.profile?.kyc_status),
                      borderRadius: "15px",
                      padding: "5px 20px",
                      display: "inline-block",
                    }}
                  >
                    {investor.profile?.kyc_status === "Y"
                      ? "Active"
                      : "Inactive"}{" "}
                  </span>
                )}
              </td> */}
                <td>
                  {investor?.OnboardJobStatus?.customer_status && (
                    <span
                      className={`investor-status investor-status-${
                        investor?.OnboardJobStatus?.customer_status ==
                        "REG_SUCCESS"
                          ? "active"
                          : "inactive"
                      }`}
                      style={{
                        ...getChipStyles(
                          investor?.OnboardJobStatus?.customer_status ===
                            "REG_SUCCESS"
                            ? "Y"
                            : "N"
                        ),
                        borderRadius: "15px",
                        padding: "5px 20px",
                        display: "inline-block",
                      }}
                    >
                      {investor?.OnboardJobStatus?.customer_status ===
                      "REG_SUCCESS"
                        ? "Active"
                        : "Inactive"}
                    </span>
                  )}
                </td>
                <td>
                  {investor?.createdAt
                    ? new Date(investor.createdAt).toLocaleDateString("en-GB")
                    : "NA"}
                </td>
                <td>
                  <div
                    className="goals-view"
                    style={{ cursor: "pointer" }}
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="View"
                    onClick={() => handleNavigation(investor?.id)}
                  >
                    <img
                      src={View}
                      alt="View"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="View"
                      // url="/rm/viewinvestor"
                    />
                  </div>
                </td>
                <td
                style={{ cursor: "pointer", textDecoration: "underline", color:"#007bff" }}
                  onClick={() => {
                    loginCustomer(investor?.mobile);
                  }}
                >
                  Login as customer
                </td>
              </tr>
            ))
          ) : (
            <>
              <tr style={{ height: "100px" }}>
                <td colSpan="12" className="no-data-message text-center">
                  No Investor Found.
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Investor;
